module.exports = "img/flags/US.982e6f9.png";